import { render } from "./MeetingInfoWithPopup.vue?vue&type=template&id=8b5054b0&scoped=true&ts=true&lang=pug"
import script from "./MeetingInfoWithPopup.vue?vue&type=script&lang=ts"
export * from "./MeetingInfoWithPopup.vue?vue&type=script&lang=ts"

import "./MeetingInfoWithPopup.vue?vue&type=style&index=0&id=8b5054b0&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b5054b0"]])

export default __exports__